import { useParams } from 'react-router-dom';
import { WebFormConfigurator } from '../components/webFormConfigurator';

export const WebFormsDetailFormPage = () => {
  const params = useParams();

  if (!params.name) return null;

  return <WebFormConfigurator formName={params.name} />;
};
